import { Button, Dropdown } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import FilterCell from "./FilterCell";

export default function MobileFilters({ table }) {
  return table.getAllLeafColumns().map((column) => (
    <div key={column.id}>
      <div key={column.id}>
        {column.getCanFilter() && (
          <Dropdown>
            <Dropdown.Toggle
              as="span"
              style={{
                cursor: "pointer",
              }}
            >
              <Button variant="light" size="sm">
                {column.columnDef.header}{" "}
                <FaFilter
                  size={12}
                  style={{
                    color: column.getFilterValue() ? "#0E91C6" : "#999",
                  }}
                />
              </Button>
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                minWidth: "250px",
                padding: "0.5rem",
              }}
            >
              <FilterCell
                column={column}
                onFilterChange={(value) => column.setFilterValue(value)}
              />
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
    //Add dropdown sort
  ));
}
